import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { mmtc_buy_requestApi } from "../../app/slices/mmtc/mmtc_buy_requestSlice";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from "@mui/material";
import { IconButton } from "@mui/material";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI

import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";
import axiosInstance from "../../utils/axiosInstance";

export default function Mmtc_buy_request() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(mmtc_buy_requestApi(queryParams));
  // }, [dispatch, queryParams]);

  const [filterData, setFilterData] = useState({
    name: "",
    customerRefNo: "",
    quoteId: "",
    orderId: "",
    merchantTransactionId: "",
    startDate: "",
    endDate: "",
  });

  const url = `/api/admin/mmtc-buy-req/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    //  console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //   else {
    //    // toast.success(message);
    //  }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.mmtc_buy_request.mmtc_buy_request.data,
  );
  // console.log("sliceResponse: ", sliceResponse?.filter((e) =>e.order_id ));
  const stateLoading = useSelector((state) => state.mmtc_buy_request.loading);

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogLoading, setDialogLoading] = useState(false);
  // console.log(
  //   "sliceResponse::::::4444444444444444444444:::::::::::::::::::::",
  //   selectedRow,
  // );

  const handleView = async (rowData) => {
    try {
      setDialogLoading(true);
      setOpenDialog(true);
      const { data } = await axiosInstance.post(
        `/getOrderDetailsMMTCPamp`,
        { order_id: rowData.order_id, type: "BUY" },
        // { headers }
      );
      // const { data } = await axios.post(
      //   `${baseUrl}/getOrderDetailsMMTCPamp`,
      //   { order_id: rowData.order_id, type: "BUY" },
      //   { headers }
      // );
      setSelectedRow(data.data);

      // setSelectedOrder(data?.data);
    } catch (error) {
      toast.error("Failed to load order details!");
    } finally {
      setDialogLoading(false);
    }
  };
  // const handleView = async (rowData) => {
  //   setOpenDialog(true);

  //   const responses = await axios.post(
  //     `${baseUrl}/getOrderDetailsMMTCPamp`,
  //        {
  //         order_id: rowData.order_id,
  //         type: "BUY",
  //       },

  //     {
  //       headers,
  //     }
  //   );

  //   // console.log("responses++++++++++++++++++++++", responses.data);
  //   setSelectedRow(responses.data.data);
  // };

  const handleCloseDialog = () => {
    setSelectedRow(null);
    setOpenDialog(false);
  };
  const getValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? value
      : "---";
  };

  const getCurrencyValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? `₹${value}`
      : "---";
  };

  const getDateValue = (value) => {
    return value ? new Date(value).toLocaleDateString() : "---";
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("customerName", {
      header: "Name",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerName);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerName}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerName}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
      Cell: (cell) => cell.row.original?.phone,
    }),
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),

    // columnHelper.accessor("currencyPair", {
    //   header: "Currency Pair",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.currencyPair || "N/A",
    // }),
    // columnHelper.accessor("type", {
    //   header: "Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.type || "N/A",
    // }),
    // columnHelper.accessor("transactionRefNo", {
    //   header: "Transaction Ref No",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.transactionRefNo);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.transactionRefNo}>
    //         <>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.transactionRefNo}
    //         </>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("value", {
    //   header: "Value",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.value,
    // }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: (cell) => cell.row.original?.quantity,
    }),
    columnHelper.accessor("type", {
      header: "Type",
      size: 30,
      Cell: (cell) => cell.row.original?.type,
    }),
    columnHelper.accessor("preTaxAmount", {
      header: "Pre Tax Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.preTaxAmount,
    }),

    columnHelper.accessor("taxAmmount", {
      header: "Tax Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.taxAmount,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.totalAmount,
    }),

    // columnHelper.accessor("tax1Amt", {
    //   header: "Tax 1 Amount",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.tax1Amt || "N/A",
    // }),
    // columnHelper.accessor("tax2Amt", {
    //   header: "Tax 2 Amount",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.tax2Amt || "N/A",
    // }),

    // columnHelper.accessor("transactionOrderID", {
    //   header: "Transaction Order ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.transactionOrderID);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.transactionOrderID}>
    //         <>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.transactionOrderID}
    //         </>
    //       </Tooltip>
    //     );
    //   },
    // }),

    // columnHelper.accessor("quoteId", {
    //   header: "Quote ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.quoteId);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.quoteId}>
    //         <>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.quoteId}
    //         </>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("calculationType", {
    //   header: "Calculation Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.calculationType || "N/A",
    // }),
    // columnHelper.accessor("transactionDate", {
    //   header: "Transaction Date",
    //   size: 30,
    //   Cell: (cell) =>
    //     cell.row.original.transactionDate
    //       ? cell.row.original.transactionDate?.split("T")[0]
    //       : "N/A",
    // }),
    columnHelper.accessor("order_id", {
      header: "Order ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.order_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.order_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.order_id}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("merchantTransactionId", {
      header: "MerchantTransaction ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("quoteId", {
      header: "Quote ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.quoteId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.quoteId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.quoteId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("billingAddressId", {
      header: "Billing Address ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.billingAddressId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.billingAddressId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.billingAddressId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("pgPaymentId", {
      header: "PG Payment ID",
      size: 30,
      Cell: (cell) => cell.row.original?.pgPaymentId,
    }),

    columnHelper.accessor("pgOrderId", {
      header: "PG Order ID",
      size: 30,
      Cell: (cell) => cell.row.original?.pgOrderId,
    }),

    columnHelper.accessor("pgAmount", {
      header: "PG Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.pgAmount,
    }),

    columnHelper.accessor("pgProvider", {
      header: "PG Provider",
      size: 30,
      Cell: (cell) => cell.row.original?.pgProvider,
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
  ];

  columns.unshift(
    columnHelper.accessor("action", {
      header: "Action",
      size: 30,
      Cell: (cell) => (
        <>
          {cell.row.original.order_id && (
            <Tooltip title="Check Status">
              <IconButton
                onClick={() => handleView(cell.row.original)}
                color="primary"
              >
                <VisibilityOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    }),
  );

  return (
    <>
      {/*  */}
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"mmtc_buy_request"}
        setFilterData={setFilterData}
      />
      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Box mt={2}>
        {loader ? (
          <Loader />
        ) : (
          <CustomTable
            columns={columns}
            data={results}
            loading={loader}
            permissionKey="MMTCBuyRequest"
          />
        )}
      </Box>

      <>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            <strong style={{ fontSize: 18 }}>Status</strong>
            <Tooltip title="Close">
              <IconButton
                sx={{ float: "right" }}
                onClick={() => {
                  setOpenDialog(false);
                }}
                aria-label="delete"
                size="small"
              >
                <CloseIcon
                  fontSize="inherit"
                  color="error"
                  sx={{ color: "red" }}
                />
              </IconButton>
            </Tooltip>
          </DialogTitle>
          <DialogContent dividers>
            {dialogLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "300px",
                }}
              >
                <CircularProgress size={60} sx={{ color: "#1976d2" }} />
              </Box>
            ) : selectedRow ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* Row 1 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>transactionId Id:</strong>{" "}
                      {getValue(selectedRow.transactionId)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>Order Id:</strong> {getValue(selectedRow.orderId)}
                    </Typography>
                  </Box>
                </Box>
                {/* Row 2 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>product_sku</strong>{" "}
                      {getValue(selectedRow.product_sku)}
                    </Typography>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>clientOrderId:</strong>{" "}
                      {getValue(selectedRow.clientOrderId)}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>type:</strong> {getValue(selectedRow.type)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>quantity:</strong>{" "}
                      {getValue(selectedRow.quantity)}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 5 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>preTaxAmount:</strong>{" "}
                      {getValue(selectedRow.preTaxAmount)}{" "}
                      {/* {getValue(selectedRow.intervalType)} */}
                    </Typography>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>total Amount:</strong>{" "}
                      {getCurrencyValue(selectedRow.totalAmount)}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>invoiceId:</strong>{" "}
                      {getValue(selectedRow.invoiceId)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>refundStatus:</strong>{" "}
                      {getValue(selectedRow.refundStatus)}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>couponDetails:</strong>{" "}
                      {getCurrencyValue(selectedRow.couponDetailsAmount)}
                    </Typography>
                  </Box>
                </Box>

                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    borderBottom: 1,
                    borderRadius: 1,
                  }}
                  variant="h6"
                >
                  Billing Address
                </Typography>

                {/* Row 10 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>Name:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.name)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>mobileNumber :</strong>{" "}
                      {getValue(selectedRow.billingAddress?.mobileNumber)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>customerRefNo :</strong>{" "}
                      {getValue(selectedRow.billingAddress?.customerRefNo)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>type:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.type)}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 11 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>line1:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.line1)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>line2:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.line2)}
                    </Typography>
                  </Box>
                </Box>

                {/* Row 12 */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>country:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.country)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>state:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.state)}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>city:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.city)}
                    </Typography>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body1">
                      <strong>zip:</strong>{" "}
                      {getValue(selectedRow.billingAddress?.zip)}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                ></Box>
              </Box>
            ) : (
              <>
                <Box textAlign="center" py={5}>
                  <Typography>No details available.</Typography>
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      </>
    </>
  );
}
